exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-link {\n  cursor: pointer;\n}\n.uu5-bricks-link.uu5-common-disabled:hover {\n  text-decoration: inherit;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/link.less
// module id = 227
// module chunks = 0